<template>
  <v-app-bar app>
    <v-toolbar-title>
      <router-link to="/">
        <v-img
          :src="require(`@/assets/game_logo_${$i18n.locale == 'ru' ? 'ru' : 'en'}.png`)"
          style="height:48px"
        ></v-img>
      </router-link>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <v-btn class="mr-2" :to="{ name: 'dev' }" v-text="$t('dev')" v-if="isAdmin"></v-btn>
    <v-btn class="mr-2" :to="{ name: 'play' }" v-text="$t('release')" v-if="isAdmin"></v-btn>

    <v-btn class="mr-2" :to="{ name: 'signin' }" v-text="$t('sign_in')" v-if="!isAuthenticated"></v-btn>
    <v-btn color="success" :to="{ name: 'signup' }" v-text="$t('sign_up')" v-if="!isAuthenticated"></v-btn>

    <v-btn v-text="$t('sign_out')" v-if="isAuthenticated" @click="signOut()"></v-btn>

    <!-- <v-menu :close-on-content-click="false" :nudge-width="200" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on" :loading="isLoading">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ currentUser.first_name }} {{ currentUser.last_name }}</v-list-item-title>
              <v-list-item-subtitle v-text="currentUser.email"></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-item>
            <v-list-item-action>
              <v-switch :input-value="!!darkTheme" @change="setTheme"></v-switch>
            </v-list-item-action>
            <v-list-item-title v-text="$t('dark_theme')"></v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-row>
              <v-col :cols="locales.length >= 3 ? 4 : locales.length === 2 ? 6 : 12" class="text-center" v-for="locale in locales" :key="locale">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn text @click="setLocale(locale)" v-on="on">
                      <v-icon v-if="$i18n.locale === locale" left>mdi-check</v-icon> <img :src="require(`@/assets/${locale}.svg`)" width="32" height="32" />
                    </v-btn>
                  </template>
                  <span v-text="$t('lang', locale)"></span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-btn text @click="signOutWindow()" v-text="$t('sign_out')"></v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu> -->
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex'
// import { LOCALES } from '@/common/config'

export default {
  // data () {
  //   return {
  //     locales: LOCALES
  //   }
  // },
  name: 'nav-bar',
  computed: {
    ...mapGetters(['darkTheme']),
    ...mapGetters('auth', ['isAuthenticated', 'isAdmin', 'isLoading']),

    showGame () {
      if (this.$route.meta) {
        if (this.$route.meta.game !== undefined && this.$route.meta.base !== undefined && this.$route.meta.module !== undefined) {
          return true
        }
      }

      return false
    }
  },
  methods: {
    signOut () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'home' })
      })
    }
    // setLocale (value) {
    //   this.$store.dispatch('setLocale', value).then(() => {
    //     this.$vuetify.lang.current = this.$store.getters.locale
    //     this.$i18n.locale = this.$store.getters.locale
    //   })
    // }
    // setTheme (value) {
    //   this.$store.dispatch('setDarkTheme', !!value).then(() => {
    //     this.$vuetify.theme.dark = this.$store.getters.darkTheme
    //   })
    // }
  }
}
</script>

<style>
a {
 text-decoration: none;
 color: inherit;
}
</style>
